import React, { useEffect, useState } from 'react';
import style from './style';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import AttributeValueForm from '../../../../../attribute-values/AttributeValueForm';

const Attribute = ({
  contexteAttribute,
  onValidateSuccess,
  currentValue,
  disabled = false,
  variant,
  attributeIndex,
  setSelectedAttribute = () => {}
}) => {
  const { classes } = style();
  const [isAttributeEdited, setIsAttributeEdited] = useState(false);
  const parsedContexteAttribute = {
    ...contexteAttribute,
    values: (contexteAttribute.values ?? []).map((v) => v.value ?? v),
  };

  useEffect(() => {
    setSelectedAttribute(currentValue)
    // eslint-disable-next-line
  }, [currentValue]);

  const addAttributeValue = (data, attributeValue) => {
    if (data.value) {
      onValidateSuccess(
        { label: data.label, values: [data.value] },
        attributeValue
      );
    } else {
      onValidateSuccess(data, attributeValue);
    }
  };

  const getValueComp = () => {
    if(currentValue?.values && !currentValue?.values.length) return i18next.t('notSpecified');
    return (
      currentValue?.values &&
      currentValue?.values.map((value) => {
        if (value.value) {
          return <span className={classes.multipleValue}>{value.value}</span>;
        }
        return <span className={classes.multipleValue}>{value}</span>;
      })
    );
  };

  const displayValue = () =>
    currentValue?.value ?? getValueComp() ?? i18next.t('notSpecified');

  const parseLabel = (value) => {
    return variant === 'contextGraph'
      ? `${String(attributeIndex + 1).padStart(2, '0')}.${value}`
      : value;
  };

  const containerClass =
    variant === 'contextGraph'
      ? `${classes.container} ${classes.contextGraphContainer}`
      : classes.container;

  return (
    <div className={classes.root}>
      <div className={containerClass}>
        <div className={classes.label}>
          {parseLabel(parsedContexteAttribute.label)}
          {parsedContexteAttribute.isRequired && ' *'}
        </div>

        {(isAttributeEdited && !disabled)
          ? (
            <AttributeValueForm
              bondType={parsedContexteAttribute.bondType}
              formId={'editAttributeValue'}
              attributeValue={parsedContexteAttribute}
              submitHandler={addAttributeValue}
              setSelectedAttribute={() => setIsAttributeEdited()}
              onCancel={() => setIsAttributeEdited(false)}
              onValidateSuccess={addAttributeValue}
              id={parsedContexteAttribute.id}
            />
          )
          : disabled
            ? (
              <div className={classes.typeContainer}>
                <div className={classes.values}>{displayValue()}</div>
              </div>
            )
            : (
              <div
                className={classes.valuesContainer}
                onClick={() => setIsAttributeEdited(true)}
              >
                <div className={classes.values}>{displayValue()}</div>
                <EAIcon icon={'edit_filled'} className={classes.editIcon} />
            </div>
          )
        }

      </div>
    </div>
  );
};

export default Attribute;
